import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCommentsQuery, fetchDeleteComment } from "../../lib/community";
import { Comment } from "./Comment";
import { useNavigate } from "react-router";

const PAGE_SIZE = 12;

export default function CommentTab({ search }: { search?: string }) {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["posts", search ?? ""],
    queryFn: ({ pageParam = 0 }) =>
      fetchCommentsQuery({ pageParam, pageSize: PAGE_SIZE, search }),
    getNextPageParam: (lastPage, allPages) =>
      lastPage && lastPage.length === PAGE_SIZE
        ? allPages.length * PAGE_SIZE
        : undefined,
    initialPageParam: 0,
  });
  const navigate = useNavigate();
  const handleDelete = async (commentId: string) => {
    const result = await fetchDeleteComment(commentId);
    if (result) {
      refetch();
    } else {
      console.error(result.error);
    }
  };

  const comments = data ? data.pages.flat() : [];

  return (
    <div>
      {comments.length > 0 ? (
        <>
          {comments.map((comment) => (
            <Comment
              key={comment.id}
              comment={comment}
              onDelete={() => handleDelete(comment.id)}
            />
          ))}

          {hasNextPage && (
            <div className="flex justify-center mt-6">
              <button
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
                className="px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
              >
                {isFetchingNextPage ? "Loading..." : "Load more"}
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="text-center text-gray-500 mt-8">
          {search ? "No comments match your search" : "No comments found"}
        </div>
      )}

      {isLoading && (
        <div className="text-center text-gray-400 py-6">Loading...</div>
      )}
    </div>
  );
}
